const accordionData = [
  {
    title: 'Who can participate?',
    content: `Everyone studying in the institution except the 1st year students are eligible to participate in the event.`
  },
  {
    title: 'Who can attend?',
    content: `Anyone studying in the Institution can attend the events as a spectator.`
  },
  {
    title: 'Can I register for multiple events?',
    content: `No, you cannot register for multiple events because all of them will take place simultaneously.`
  },
  {
    title: 'Can a non-contestant take part in the fun-stalls?',
    content: `Yes, stalls are for everyone, from the students to the faculty. Anyone can take part in stalls.`
  },
  {
    title: 'Will I be missing any of my academic classes for these events?',
    content: `No, all the events are scheduled in such a way that no student will miss his/her/their classes as all events will happen in non-academic hours.`
  },
  {
    title: 'Do I have to take permission from my department before participation?',
    content: `No, as academic activities won't be effected, there is no need of permission.`
  },
  {
    title: 'What to bring to an event?',
    content: `You are required to wear your id card to the event.`
  },
  {
    title: 'Will I have fun in LitFest if I am a beginner?',
    content: `Without a doubt, LitFest is a beginner friendly event where participants are meant to cultivate their skills!`
  }
];

export default accordionData;